import { combineReducers } from "redux";
import examDetailsInfo from "./examDetailsReducer";
import institutesDetailsInfo from "./institutesDetailsReducer";
import commonData from "./commonData";
import currentUser from "./currentUser";
import personalInfo from './personalInfo';
import stateTransition from "./stateTransitionReducer";
import ConfirmationInfo from "./confirmationInfo";
import reviewConfirm from "./reviewConfirm";
import transcriptHistory from './transcriptHistory';
import termsAndConditionsReducer from './termsAndConditionsReducer'


export default combineReducers({
    examDetailsInfo,
    institutesDetailsInfo,
    commonData,
    currentUser,
    personalInfo,
    stateTransition, 
    ConfirmationInfo,
    reviewConfirm,
    transcriptHistory,
    termsAndConditionsReducer
});

